import React, {Component} from 'react';
import AppConfig from "../AppConfig";
import Mapa from "../home/homeComponents/Mapa";
import Footer from "../shared/Footer";
import WczytajNumerBiletu from "./fakturyComponents/WczytajNumerBiletu";
import NumerWczytany from "./fakturyComponents/NumerWczytany";
import WeryfikacjaFirmy from "./fakturyComponents/WeryfikacjaFirmy";

let URL = AppConfig.HOST_API();

export default class GeneratorFaktur extends Component {

    constructor(props) {
        super(props);

        this.state = {
            biletData: null,
            buttonLoader: false,
            checkFirma: false,
            idBi: null,
            idValid: true,
            idSuccess: false
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        return <div>
            <div className="wynajemNaglowek przerywnik">
                <div className="container text-center">
                    <h2><b>Oferujemy wynajem pojazdów wraz z kierowcą dla potrzeb klienta.</b></h2>
                    <h4>Aby złożyć zamówienie należy wypełnić poniższy formularz.</h4>
                </div>
            </div>
            <div className="panelPaddingMobilka"
                 style={{backgroundColor: '#f9f9f9', paddingTop: 20, paddingBottom: 15}}>
                <div className="container paddingContainerMobilka" style={{paddingLeft: 0, paddingRight: 0}}>
                    <div className="wynik ramka formularzWynajmu"
                         style={{paddingTop: 50, paddingBottom: 50, marginTop: 0}}>
                        {this.state.checkFirma ? <WeryfikacjaFirmy dokumentItem={this.state.dokumentItem} idBi={this.state.idBi} goBack={()=>this.setState({checkFirma: false})}/> : <div>
                        {this.state.idSuccess ?
                            <NumerWczytany biletData={this.state.biletData}
                                           idBi={this.state.idBi}
                                           setCheckFirma={()=>this.setState({checkFirma: true})}
                                           setDokumentItem={(item) => this.setState({dokumentItem: item})}/>
                                           :
                            <WczytajNumerBiletu
                                idBi={this.props.match !== undefined && this.props.match !== null ? this.props.match.params.idBi : null}
                                idValid={this.state.idValid}
                                idSuccess={this.state.idSuccess}
                                buttonLoader={this.state.buttonLoader}
                                setBiletData={(val) => this.setState({biletData: val})}
                                setIdValid={(val) => this.setState({idValid: val})}
                                setIdSuccess={(val) => this.setState({idSuccess: val})}
                                setIdBi={(val)=>this.setState({idBi: val})}
                                setButtonLoader={(val) => this.setState({buttonLoader: val})}
                            />}</div>}
                    </div>
                </div>
            </div>
            <Mapa/>
            <Footer/>
        </div>
    }
}



// WEBPACK FOOTER //
// ./src/components/koszyk/GeneratorFaktur.js